import { useState } from "react";
import { useHistory } from "react-router-dom";
import { FileUploader } from "react-drag-drop-files";
import TabOnboardingCompliance from "components/__new/common/TabOnboardingCompliance";
import Maybe from "components/__new/common/Maybe";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import getFileSize from "utils/getFileSize";
import { toast } from "react-toastify";
import iconCloud from "assets/images/icons/cloud.svg";
import iconFile from "assets/images/icons/file.svg";
import { ReactComponent as IconsTimes } from "assets/images/icons/project-icons/times.svg";


const OnboardingComplianceCac = () => {
    const history = useHistory();
    
    
    const [cacFileUpload, setCacFileUpload] = useState(null);

    
    const submitForm = async (e) => {
        e.preventDefault();
        history.push("/get-started/compliance/cac/success");
    }
    
    
    return (
        <div>
            
            <DynamicHeadTag
                headerText="CAC Compliance"
            />
            
            <div className="py-14">
                <TabOnboardingCompliance index="2" />
            </div>
            
            <div className="box">
                <div className="mx-auto my-8 max-w-md">
                    <div className="text-center">
                        <div className="text-2xl font-bold">
                            CAC Status Report
                        </div>
                        
                        <div className="mt-2 text-[#374151]">
                            Kindly upload your Company’s Corporate Affairs Commission (CAC) status report as part of our commitment to regulatory compliance and maintaining accurate records.
                        </div>
                    </div>
                    
                    <form onSubmit={submitForm} className="max-w-sm mx-auto">
                        <div className="my-10">
                            
                            
                            
                            <div className="overflow-hidden">
                                <Maybe condition={cacFileUpload === null}>
                                    <FileUploader handleChange={(e) => setCacFileUpload(e)} multiple={false} onTypeError={(err) => toast.error(err)}>
                                        <div className="w-full h-32 flex items-center justify-center text-center cursor-pointer bg-white border border-gray-200 rounded-lg">
                                            <div>
                                                <div className="h-14 flex">
                                                    <img src={iconCloud} alt="file upload" className="object-contain mx-auto" />
                                                </div>
                                                <div className="mt-2">
                                                    <span className="font-medium text-ep-primary">
                                                        Click to upload&nbsp;
                                                    </span>
                                                    <span className="text-fade">
                                                        or drag and drop
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </FileUploader>
                                </Maybe>

                                <Maybe condition={cacFileUpload !== null}>
                                    <div className="w-full h-20 p-4 flex items-center bg-white border border-ep-primary rounded-lg">
                                        <div className="w-12 h-12 p-3 rounded-full flex flex-shrink-0 bg-[#E5FDFF] overflow-hidden">
                                            <img src={iconFile} alt="file upload" className="object-contain mx-auto" />
                                        </div>
                                        <div className="ml-4 flex-grow ellipsis text-ep-primary">
                                            {cacFileUpload?.name}
                                        </div>
                                        <div className="mx-2 text-[#667085] uppercase">
                                            {getFileSize(cacFileUpload?.size)}
                                        </div>
                                        <div className="w-6 h-6 p-1.5 flex-shrink-0 flex items-center justify-center group hover:bg-red-500 cursor-pointer rounded-full" onClick={() => setCacFileUpload(null)}>
                                            <IconsTimes className="group-hover:svg-fill-white"/>
                                        </div>
                                    </div>
                                </Maybe>
                            </div>
                            
                            
                            
                        </div>
                        
                        <div className="mt-8">
                            <button type="submit" className="btn btn-block btn-ep-primary btn-lg">
                                Submit
                            </button>
                        </div>
                    </form>
                    
                </div>
            </div>
        </div>
    )
}


export default OnboardingComplianceCac;